import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close_icon",
  "use": "icon-close_icon-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close_icon\"><g id=\"icon-close_icon_å³é­\"><g id=\"icon-close_icon_å½¢ç¶ç»å\"><path d=\"M16.4101 4.91959L15.0842 3.59377L10.0019 8.67608L4.91959 3.59375L3.59377 4.91958L8.6761 10.0019L3.59375 15.0843L4.91958 16.4101L16.4101 4.91959Z\" /><path d=\"M15.0843 16.4101L11.3277 12.6536L12.6536 11.3277L16.4101 15.0842L15.0843 16.4101Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol